<script>
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import CKEditor from "@ckeditor/ckeditor5-vue";
// import store from "@/state/store";
// var state = store._modules.root._children.auth.state;
export default {
  page: {
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ckeditor: CKEditor.component,
  },
  data() {
    return {
      hr_leaves: [],
      leaglConditions: [
        { name: "نعم", name_en: "Yes", value: 1 },
        { name: "لا", name_en: "No", value: 0 },
      ],
      HrLeaveTypes: [],
      page: 1,
      limit: 20,
      tot_pages: 0,
      searchHrLeaveTypes: null,
      HrLeaveTypesSearchMode: false,
      searchModel: "",
      editor: ClassicEditor,
      editorConfig: {
        // The configuration of the editor.
      },
      form: { descr: "", name: "", is_legal: "" },
      openModal: false,
      secondModal: false,
      // state: state,
    };
  },
  methods: {
    addHrLeaveTypes() {
      //   var data = {
      //     title: "popups.add",
      //     inputs: [
      //       { model: "name", type: "text", label: "hr_leave_types.name" },
      //       {
      //         model: "is_legal",
      //         type: "select",
      //         options: (() => {
      //           return this.leaglConditions.map((data) => {
      //             return {
      //               value: data.value,
      //               label: this.$i18n.locale == "ar" ? data.name : data.name_en,
      //             };
      //           });
      //         })(),
      //         label: "hr_leave_types.is_legal",
      //       },
      //       { model: "descr", type: "textarea", label: "hr_leave_types.descr" },
      //     ],
      //     buttons: [
      //       {
      //         text: "popups.add",
      //         closer: true,
      //         color: "primary",
      //         handler: (obj) => {
      //           this.http.post("hr-leave-types", obj).then(() => {
      //             this.get(this.page);
      //           });
      //         },
      //       },
      //       {
      //         text: "popups.cancel",
      //         closer: true,
      //         color: "danger",
      //         handler: () => {
      //           console.log("Like Clicked");
      //         },
      //       },
      //     ],
      //   };
      //   this.popup.modal(data);
      this.http.post("hr-leave-types", this.form).then(() => {
        this.openModal = false;
        this.form = { descr: "", name: "", is_legal: "" };
        this.get(this.page);
      });
    },
    editHrLeaveTypes() {
      //   var data = {
      //     title: "popups.edit",
      //     inputs: [
      //       {
      //         model: "name",
      //         type: "text",
      //         label: "hr_leave_types.name",
      //         value: app.name,
      //       },
      //       {
      //         model: "is_legal",
      //         type: "select",
      //         value: app.is_legal,
      //         options: (() => {
      //           return this.leaglConditions.map((data) => {
      //             return {
      //               value: data.value,
      //               label: this.$i18n.locale == "ar" ? data.name : data.name_en,
      //             };
      //           });
      //         })(),
      //         label: "hr_leave_types.is_legal",
      //       },
      //       {
      //         model: "descr",
      //         type: "ckeditor",
      //         label: "hr_leave_types.descr",
      //         value: app.descr,
      //       },
      //     ],
      //     buttons: [
      //       {
      //         text: "popups.edit",
      //         closer: true,
      //         color: "primary",
      //         handler: (obj) => {
      //           this.http.put("hr-leave-types", app.id, obj).then(() => {
      //             this.get(this.page);
      //           });
      //         },
      //       },
      //       {
      //         text: "popups.cancel",
      //         closer: true,
      //         color: "danger",
      //         handler: () => {
      //           console.log("Like Clicked");
      //         },
      //       },
      //     ],
      //   };
      //   this.popup.modal(data);
      this.http.put("hr-leave-types", this.form.id, this.form).then(() => {
        this.secondModal = false;
        this.form = { descr: "", name: "", is_legal: "" };
        this.get(this.page);
      });
    },
    search() {
      if (!this.searchModel.length) return this.get(1);
      this.HrLeaveTypesSearchMode = true;
      this.tot_pages = 0;
      this.http
        .post("hr-leave-types/search", {
          search: this.searchModel,
          limit: this.limit,
          page: this.page,
          col: "name",
        })
        .then((res) => {
          this.HrLeaveTypes = res.data;
          this.tot_pages = Math.ceil(res.tot / this.limit);
        });
    },
    getHrLeaveTypes() {
      this.http.get("hr-leave-types").then((res) => {
        this.HrLeaveTypes = res.data;
      });
    },
    deleteHrLeaveTypes(app) {
      var data = {
        title: "popups.delete",
        msg: "popups.delmessage",
      };
      this.popup.confirm(data).then((resp) => {
        if (resp) {
          this.http.delete("hr-leave-types", app.id).then(() => {
            this.get(this.page);
          });
        }
      });
    },

    get(page) {
      console.log(page);
      this.http
        .post("hr-leave-types/pagination", {
          limit: this.limit,
          page: page,
        })
        .then((res) => {
          this.page = page;
          this.tot_pages = Math.ceil(res.tot / this.limit);
          this.HrLeaveTypes = res.data;
        });
    },
  },
  created() {
    this.get(1);
  },
};
</script>

<template>
  <Layout>
    <PageHeader
      :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
      :title="$t('menu.menuitems.hr.subItems.leave')"
    />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-6 mb-4">
                <div class="search-box chat-search-box w-50">
                  <div class="position-relative">
                    <!-- <input
                      @input="search()"
                      type="search"
                      class="form-control fa-lg text-light"
                      :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
                      :placeholder="$t('popups.search')"
                      v-model="searchModel"
                      style="background-color: #2a3042 !important"
                    /> -->
                    <i class="bx bx-search-alt search-icon text-light"></i>
                  </div>
                </div>
              </div>
              <div
                class="col-6"
                style="display: flex; justify-content: flex-end"
              >
                <button
                  type="button"
                  @click="openModal = true"
                  class="btn btn-light float-end mb-4"
                >
                  <span
                    class="bx bxs-plus-circle float-end fa-2x"
                    style="color: #2a3042 !important"
                  ></span>
                </button>
              </div>
            </div>

            <div class="table-responsive">
              <table
                :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
                class="table table-centered table-nowrap table-striped table-hover"
              >
                <thead>
                  <tr
                    class="text-light"
                    style="background-color: #2a3042 !important"
                  >
                    <th>#</th>
                    <th>{{ $t("hr_leave_types.name") }}</th>
                    <th>{{ $t("hr_leave_types.descr") }}</th>
                    <th>{{ $t("hr_leave_types.is_legal") }}</th>
                    <th>{{ $t("hr_leave_types.created") }}</th>
                    <th>{{ $t("hr_leave_types.updated") }}</th>
                    <th>{{ $t("hr_leave_types.operations") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(app, index) in HrLeaveTypes" :key="app" class="">
                    <td>{{ index + 1 }}</td>
                    <td>{{ app.name }}</td>
                    <td v-html="app?.descr"></td>
                    <td>
                      {{ app.is_legal ? $t("popups.yes") : $t("popups.no") }}
                    </td>
                    <td>{{ app.created.split("T")[0] }}</td>
                    <td>{{ app.updated.split("T")[0] }}</td>

                    <td class="d-flex">
                      <a
                        class="btn btn-primary mx-1"
                        @click="
                          form = app;
                          secondModal = true;
                        "
                        href="javascript: void(0);"
                        role="button"
                        >{{ $t("popups.edit") }}</a
                      >
                      <a
                        class="btn btn-danger"
                        href="javascript: void(0);"
                        role="button"
                        @click="deleteHrLeaveTypes(app)"
                        >{{ $t("popups.delete") }}</a
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- end  table -->
            <!-- Button trigger modal -->

            <div>
              <!--   Apps  Pagination     -->
              <ul
                class="pagination pagination-rounded justify-content-center mb-2"
              >
                <li class="page-item" :class="{ disabled: page == 1 }">
                  <a
                    class="page-link"
                    href="javascript: void(0);"
                    @click="searchModel ? search(page - 1) : get(page - 1)"
                    aria-label="Previous"
                  >
                    <i class="mdi mdi-chevron-left"></i>
                  </a>
                </li>
                <li
                  class="page-item"
                  :class="{ active: p == page }"
                  v-for="p in tot_pages"
                  :key="p"
                >
                  <a
                    class="page-link"
                    href="javascript: void(0);"
                    @click="searchModel ? search(p) : get(p)"
                    >{{ p }}</a
                  >
                </li>

                <li class="page-item" :class="{ disabled: page == tot_pages }">
                  <a
                    class="page-link"
                    href="javascript: void(0);"
                    @click="searchModel ? search(page + 1) : get(page + 1)"
                    aria-label="Next"
                  >
                    <i class="mdi mdi-chevron-right"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--Add modal-->
    <BModal hide-footer :title="$t('popups.add')" v-model="openModal">
      <BForm @submit.prevent="addHrLeaveTypes">
        <BFormGroup :label="$t('hr_leave_types.name')">
          <BFormInput required v-model="form.name" />
        </BFormGroup>
        <BFormGroup :label="$t('hr_leave_types.name_en')">
          <BFormInput required v-model="form.name_en" />
        </BFormGroup>
        <BFormGroup :label="$t('hr_leave_types.is_legal')">
          <BFormSelect required v-model="form.is_legal">
            <option value="" disabled>
              {{ $t("hr_leave_types.is_legal") }}
            </option>
            <option
              v-for="cond in leaglConditions"
              :key="cond.value"
              :value="cond.value"
            >
              {{ $i18n.locale === "ar" ? cond.name : cond.name_en }}
            </option>
          </BFormSelect>
        </BFormGroup>
        <BFormGroup :label="$t('hr_leave_types.descr')">
          <ckeditor
            :editor="editor"
            v-model="form.descr"
            :config="editorConfig"
          ></ckeditor>
        </BFormGroup>
        <div class="mt-3 d-flex justify-content-end">
          <BButton type="submit" variant="primary">{{
            $t("popups.add")
          }}</BButton>
          <BButton
            class="mx-2"
            variant="secondary"
            @click="openModal = false"
            >{{ $t("popups.cancel") }}</BButton
          >
        </div>
      </BForm>
    </BModal>
    <!--end-->

    <!--edit modal-->
    <BModal hide-footer :title="$t('popups.edit')" v-model="secondModal">
      <BForm @submit.prevent="editHrLeaveTypes">
        <BFormGroup :label="$t('hr_leave_types.name')">
          <BFormInput v-model="form.name" />
        </BFormGroup>
        <BFormGroup :label="$t('hr_leave_types.is_legal')">
          <BFormSelect v-model="form.is_legal">
            <option value="" disabled>
              {{ $t("hr_leave_types.is_legal") }}
            </option>
            <option
              v-for="cond in leaglConditions"
              :key="cond.value"
              :value="cond.value"
            >
              {{ $i18n.locale === "ar" ? cond.name : cond.name_en }}
            </option>
          </BFormSelect>
        </BFormGroup>
        <BFormGroup :label="$t('hr_leave_types.descr')">
          <ckeditor
            :editor="editor"
            v-model="form.descr"
            :config="editorConfig"
          ></ckeditor>
        </BFormGroup>
        <div class="mt-3 d-flex justify-content-end">
          <BButton type="submit" variant="primary">{{
            $t("popups.add")
          }}</BButton>
          <BButton
            class="mx-2"
            variant="secondary"
            @click="secondModal = false"
            >{{ $t("popups.cancel") }}</BButton
          >
        </div>
      </BForm>
    </BModal>
  </Layout>
</template>

<style scoped>
.btn-close {
  position: relative;
  font-size: 15px;
}
</style>
